import React from "react";
import { Box } from "@mui/material";
import { Social } from "../../../../../store/services/invitations/dto/invitations.dto";
import PartnerSocial from "../PartnerSocial";
import AddIcon from "@mui/icons-material/Add";
import { SocialList } from "./styles";
const PartnersSocialList = ({
	socials,
	dispatchId,
	canEdit
}: {
	socials: Social[];
	dispatchId: string;
	canEdit: boolean;
}) => {
	return (
		<SocialList data-dispatch-id={dispatchId}>
			{(socials || []).map(social => (
				<Box
					key={social._id}
					style={{ cursor: "pointer" }}
					onClick={() => !canEdit && window.open(social.value, "_blank")}
				>
					<PartnerSocial social_type={social.social_type} />
				</Box>
			))}
			{canEdit && (socials || []).length === 0 && (
				<Box className={"add_social"}>
					<AddIcon />
				</Box>
			)}
		</SocialList>
	);
};

export default PartnersSocialList;
